export enum CountryId {
  China = 46,
  Japan = 108,
}
